import { createSelector } from "@reduxjs/toolkit";

export const READING_STATE_ROOT_SELECTOR = state => state.reading;

export const CREATE_READING_SELECTOR = (s) => createSelector(READING_STATE_ROOT_SELECTOR, s);

export const READING_RECORDING_TIMEOUT_SECONDS = 60;

export const STUDENT_PROFILE_BOARD_ID = -2;

export const CURSOR_STATES = {
  FOLLOWING_WORD: "following_word",
  SELECTING_FIRST_WORD: "selecting_first_word",
  SELECTING_LAST_WORD: "selecting_last_word",
};

export const PROBLEMS_TYPES = {
  MISTAKE_MISPRONUNCIATION: 1,
  MISTAKE_SUBSTITUTION: 2,
  MISTAKE_OMISSION: 3,
  MISTAKE_TRANSPOSITION: 4,
  MISTAKE_FAILED_TO_READ: 5, // old type - not used

  DIFFICULTIE_REPEATED: 6,
  DIFFICULTIE_SELF_CORRECTED: 7,
  DIFFICULTIE_INSERTED: 8,
  DIFFICULTIE_DIALECT_SPEECH_IMPAIRMENT: 9,
};

export const ALL_MISTAKE_TYPES = [
  PROBLEMS_TYPES.MISTAKE_MISPRONUNCIATION,
  PROBLEMS_TYPES.MISTAKE_SUBSTITUTION,
  PROBLEMS_TYPES.MISTAKE_OMISSION,
  PROBLEMS_TYPES.MISTAKE_TRANSPOSITION,
  PROBLEMS_TYPES.MISTAKE_FAILED_TO_READ,
];
export const ALL_DIFFICULTIE_TYPES = [
  PROBLEMS_TYPES.DIFFICULTIE_REPEATED,
  PROBLEMS_TYPES.DIFFICULTIE_SELF_CORRECTED,
  PROBLEMS_TYPES.DIFFICULTIE_INSERTED,
  PROBLEMS_TYPES.DIFFICULTIE_DIALECT_SPEECH_IMPAIRMENT,
];

export const PROBLEMS = {
  // MISTAKES / ERRORS
  [PROBLEMS_TYPES.MISTAKE_MISPRONUNCIATION]: { type: PROBLEMS_TYPES.MISTAKE_MISPRONUNCIATION, buttonLabel: "Mispronunciation", infoLabel: "Mispronunciation", color: "#0B49A1", textColor: "#FFFFFF" },
  [PROBLEMS_TYPES.MISTAKE_SUBSTITUTION]: { type: PROBLEMS_TYPES.MISTAKE_SUBSTITUTION, buttonLabel: "Substitution", infoLabel: "Substitution", color: "#217049", textColor: "#FFFFFF" },
  [PROBLEMS_TYPES.MISTAKE_OMISSION]: { type: PROBLEMS_TYPES.MISTAKE_OMISSION, buttonLabel: "Omission", infoLabel: "Omission", color: "#FBA40D", textColor: "#FFFFFF" },
  [PROBLEMS_TYPES.MISTAKE_TRANSPOSITION]: { type: PROBLEMS_TYPES.MISTAKE_TRANSPOSITION, buttonLabel: "Transposition", infoLabel: "Transposition", color: "#932542", textColor: "#FFFFFF" },
  [PROBLEMS_TYPES.MISTAKE_FAILED_TO_READ]: { isCancelled: true, type: PROBLEMS_TYPES.MISTAKE_FAILED_TO_READ, buttonLabel: "Skipped", infoLabel: "Skipped", color: "#707070", textColor: "#FFFFFF" }, // old type - not used

  // DIFFICULTIES
  [PROBLEMS_TYPES.DIFFICULTIE_REPEATED]: { type: PROBLEMS_TYPES.DIFFICULTIE_REPEATED, buttonLabel: "Repeated", infoLabel: "Repeated", color: "#ABE6C8", textColor: "#494A6D" },
  [PROBLEMS_TYPES.DIFFICULTIE_SELF_CORRECTED]: { type: PROBLEMS_TYPES.DIFFICULTIE_SELF_CORRECTED, buttonLabel: "Self corrected", infoLabel: "Self corrected", color: "#FEDA9D", textColor: "#494A6D" },
  [PROBLEMS_TYPES.DIFFICULTIE_INSERTED]: { type: PROBLEMS_TYPES.DIFFICULTIE_INSERTED, buttonLabel: "Inserted", infoLabel: "Inserted", color: "#72A3FF", textColor: "#494A6D" },
  [PROBLEMS_TYPES.DIFFICULTIE_DIALECT_SPEECH_IMPAIRMENT]: { type: PROBLEMS_TYPES.DIFFICULTIE_DIALECT_SPEECH_IMPAIRMENT, buttonLabel: "Dialect / speech impairment", infoLabel: "Dialect / speech impairment", color: "#EFBECB", textColor: "#494A6D" },
};

export const WordsRefs = { };

export const DUMMY_STORY = "Get ready to read for 1 minute. When ready, click the “show me” button. This will start the timer and you will see a different story here.\n"
  + "Please allow the computer to access your microphone for this activity. A prompt for the microphone will show up as a pop-up. Click allow when you see the pop-up.\n"
  + "Once the time is up, the passage will disappear.\n"
  + "Good luck!";
